<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import projetoServico from '~modulos/projeto/servico';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      desabilitarBeneficiario: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      validar() {
        return this.$validator.validateAll();
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolFaturamento")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function(e) {
            _this.$set(_this.solicitacao, 'idProjeto', this.value);

            _this.setarProjeto(this.value);

            if (!this.value) return;
          });
      },
    },
    computed: {
      validarConta() {
        return this.configuracao.selecaoDeContaWeb ? 'required' : '';
      },
    },
    mounted() {
      $('label.checkbox')
        .css('margin-top', 0)
        .css('margin-bottom', 5)
        .addClass('control-label');

      this.listaDeProjetos();
      this.iniciarSelect2Projeto();
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select
            id="projeto"
            class="form-control"
            v-model="solicitacao.idProjeto"
            data-vv-name="projeto"
            v-validate="'required'">
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolFaturamento) || projeto.acompanhamentoPendente">
              {{ projeto.nomeProjeto }}

              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolFaturamento)">
                (Data limite até: {{ projeto.dataLimiteSolFaturamento | formatarData }})
              </template>

              <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolFaturamento)">
                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input
            type="text"
            class="form-control"
            v-model="solicitacao.projeto.nomeProjeto"
            disabled>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">
    
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nome')}">
          <label class="control-label" for="nome">Nome</label>

          <input 
              type="text"
              class="form-control"
              id="nome"
              v-model="solicitacao.nome"
              data-vv-name="nome"
              data-vv-as="Nome do beneficiário"
              v-validate="'required'"
              maxlength="100"
              :disabled="desabilitarBeneficiario">

          <p class="text-danger" v-show="errors.has('nome')">{{ errors.first('nome') }}</p>
        </div>
      </div>
      
      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="documento">Email faturamento</label>

          <input 
              type="text"
              class="form-control"
              id="documento"
              v-model="solicitacao.documento"
              disabled>
        </div>
      </div>
    </div>
        
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('enderecoFaturamento')}">
          <label class="control-label" for="endereco-faturamento">Endereço</label>

          <input
              id="endereco-faturamento"
              class="form-control"
              type="text"
              v-model="solicitacao.enderecoFaturamento"
              data-vv-name="enderecoFaturamento"
              data-vv-as="endereço"
              v-validate="'required'"
              maxlength="100">

          <p class="text-danger" v-show="errors.has('enderecoFaturamento')">{{ errors.first('enderecoFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numeroFaturamento')}">
          <label class="control-label" for="numero-faturamento">Número</label>

          <input
              id="numero-faturamento"
              class="form-control"
              type="text"
              v-model="solicitacao.numeroFaturamento"
              data-vv-name="numeroFaturamento"
              data-vv-as="número"
              v-validate="'required'"
              maxlength="10">

          <p class="text-danger" v-show="errors.has('numeroFaturamento')">{{ errors.first('numeroFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento-faturamento">Complemento</label>

          <input
            id="complemento-faturamento"
            class="form-control"
            type="text"
            v-model="solicitacao.complementoFaturamento"
            maxlength="30">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('bairroFaturamento')}">
          <label class="control-label" for="bairro-faturamento">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro-faturamento"
                 v-model="solicitacao.bairroFaturamento"
                 data-vv-as="bairro"
                 data-vv-name="bairroFaturamento"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('bairroFaturamento')">{{ errors.first('bairroFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('cidadeFaturamento')}">
          <label class="control-label" for="cidade-faturamento">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade-faturamento"
                 v-model="solicitacao.cidadeFaturamento"
                 data-vv-as="cidade"
                 data-vv-name="cidadeFaturamento"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('cidadeFaturamento')">{{ errors.first('cidadeFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="pais">País</label>

          <input id="pais"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.pais"
                 maxlength="30">
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneFaturamento')}">
          <label class="control-label" for="telefone-faturamento">Telefone</label>

          <input
              type="text"
              class="form-control"
              id="telefone-faturamento"
              v-model="solicitacao.telefoneFaturamento"
              data-vv-as="telefone"
              data-vv-name="telefoneFaturamento"
                 maxlength="20"
              v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefoneFaturamento')">{{ errors.first('telefoneFaturamento') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group">
          <label class="control-label" for="fax-faturamento">Fax</label>

          <input
              id="fax-faturamento"
              class="form-control"
              type="text"
              maxlength="20"
              v-model="solicitacao.faxFaturamento">
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('contatoFaturamento')}">
          <label class="control-label" for="email-faturamento">Email para envio de NF <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input
            type="text"
            class="form-control"
            id="email-faturamento"
            v-model="solicitacao.contatoFaturamento"
            data-vv-as="e-mail"
            data-vv-name="contatoFaturamento"
            v-validate="`required|emailcomposto`"
            maxlength="300"
            v-caracteres-email>

          <p class="text-danger" v-show="errors.has('contatoFaturamento')">{{ errors.first('contatoFaturamento') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="contato">Contato para envio de NF/fatura <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input type="text"
                 class="form-control"
                 id="contato"
                 v-model="solicitacao.contato"
                 maxlength="100"
                 v-validate="`emailcomposto`"
                 data-vv-name="contato"
                 v-caracteres-email>

          <p class="text-danger" v-show="errors.has('contato')">{{ errors.first('contato') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pf/componentes/compartilhado/FormDadosFaturamento.vue